export const MAX_GRID_WIDTH = "1202px";
